import './rem-adapter.js'
import { ViteSSG } from 'vite-ssg'
import App from './App.vue'
import './styles.css'
import { installRouterGuards, routes } from './router'
import { collectSeoRoutes } from './utils/seo-route-data'

export async function includedRoutes() {
	const staticRoutes = routes
		.map(route => route.path)
		.filter(path => path && !path.includes(':') && !path.includes('*'))

	try {
		const seoRoutes = await collectSeoRoutes()
		return Array.from(new Set([...staticRoutes, ...seoRoutes]))
	} catch (error) {
		console.warn('Failed to collect SEO routes:', error)
		return staticRoutes
	}
}

export const createApp = ViteSSG(
	App,
	{
		routes,
		base: import.meta.env.BASE_URL,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) return savedPosition
			return { left: 0, top: 0 }
		}
	},
	({ router, initialState, isClient, onSSRAppRendered }) => {
		installRouterGuards(router)

		if (!isClient && onSSRAppRendered) {
			onSSRAppRendered(() => {
				Object.assign(initialState, router.currentRoute.value.meta.state || {})
			})
		}
	}
)
